import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { InfoCard, InfoCardHeader } from '@/components/ui/InfoCard.tsx';

interface RelatedPeopleCardSkeletonProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Ile wierszy osób odwzorować. */
  personCount?: number;
}

/** Szkielet karty „Powiązane osoby”: nagłówek z licznikiem i lista osób. */
const RelatedPeopleCardSkeleton = ({
  personCount = 3,
  ...props
}: RelatedPeopleCardSkeletonProps) => (
  <InfoCard {...props}>
    <InfoCardHeader
      title={<Skeleton className="h-3.5 w-36" />}
      aside={<Skeleton className="h-3.5 w-12" />}
    />

    <div className="flex flex-col px-5 pb-3.5 pt-2">
      {Array.from({ length: personCount }).map((_, index) => (
        <div
          key={index}
          className={cn(
            'flex items-center gap-[11px] py-[11px]',
            index > 0 && 'border-t border-neutral-100',
          )}
        >
          <Skeleton className="size-7 rounded-full" />
          <div className="flex flex-col gap-1.5">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-3.5 w-24" />
          </div>
        </div>
      ))}
    </div>
  </InfoCard>
);

export default RelatedPeopleCardSkeleton;
